

export default function EmailIcon({ className }) {
    return <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.66634 2.66699H13.333C14.0664 2.66699 14.6664 3.26699 14.6664 4.00033V12.0003C14.6664 12.7336 14.0664 13.3336 13.333 13.3336H2.66634C1.93301 13.3336 1.33301 12.7336 1.33301 12.0003V4.00033C1.33301 3.26699 1.93301 2.66699 2.66634 2.66699Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M14.6664 4.00049L7.99967 8.66713L1.33301 4.00049" stroke="white" stroke-linecap="round" stroke-linejoin="round" />

    </svg>


}